<template>
  <BaseModalLarge
    :heading="$t('waiting_list.modal_title')"
    :parentRoute="parentRouteName"
  >
    <WaitingList v-if="waitingListEnabled" />
    <EmptyPageContent
      v-if="!waitingListEnabled"
      imageName="marketing-waitinglist"
      :text="{
        title: $t('waiting_list.disabled.heading'),
        description: $t('waiting_list.disabled.info'),
        btnPrimary: $t('waiting_list.enable_waiting_list')
      }"
      @click="enable"
    />
  </BaseModalLarge>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import EmptyPageContent from '@/components/EmptyPageContent.vue';
import eventBus from '@/event-bus';
import { flash } from '@/helpers/ui';
import WaitingList from '@/modals/waiting-list/WaitingList.vue';
import { useCompanyStore } from '@/stores/company';
import { useOnboardingStore } from '@/stores/onboarding';

defineProps<{
  parentRouteName: string;
}>();

const { t } = useI18n();

const companyStore = useCompanyStore();
const { currentOnboardingFlow } = storeToRefs(useOnboardingStore());
const waitingListEnabled = computed(
  () => companyStore.company.settings.bookings.waitingListEnabled,
);

const enable = () => {
  const input = {
    settings: {
      bookings: {
        waitingListEnabled: true,
      },
    },
  };

  companyStore.updateCompany(input).then(() => {
    flash(t('global.flash.waiting_list_enabled'));
    if (currentOnboardingFlow.value === 'marketing') {
      eventBus.$emit('open-task-menu');
      currentOnboardingFlow.value = '';
    }
  });
};
</script>
